import { FiUser, FiSettings, FiLogOut } from "react-icons/fi";
import ThemeToggle from "../../Hooks/ThemeToggle";

const ProfilePopover = ({onViewProfile }) => {
  return (
    <div className="profile-popover">
      <div className="profile-info">
        <img src="https://i.pravatar.cc/60" alt="user" />
        <div>
          <strong>Roop Chandra</strong>
          <span className="status online">Online</span>
        </div>
      </div>

      <div className="popover-actions">
        <div className="popover-item" onClick={() => onViewProfile()}>
          <FiUser /> View profile
        </div>
        <div className="popover-item">
          <FiSettings /> Settings
        </div>
        <ThemeToggle/>
        <div className="popover-item logout">
          <FiLogOut /> Sign out
        </div>
      </div>
    </div>
  );
};

export default ProfilePopover;
